var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5695 13.7975L26.0149 5.33325H24.2506L17.7857 12.6827L12.6222 5.33325H6.66675L14.4749 16.4469L6.66675 25.323H8.43118L15.2583 17.5617L20.7113 25.323H26.6667L18.569 13.7975H18.5695ZM16.1528 16.5448L15.3617 15.4381L9.06693 6.63226H11.777L16.8569 13.7389L17.6481 14.8455L24.2514 24.083H21.5413L16.1528 16.5452V16.5448Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6a68ddabe6ba39f0316f892d9698452f.svg";
export { ForwardRef as ReactComponent };